import { useDisplayABT } from '@domains/pdp-common';

const BASE_KEY = 'ab_pdp_subtab_size';

/**
 * 사이즈탭 ABT 훅
 * - CTRL_A: 메인 브랜치 (기존) - 상품설명 탭에 SizeRecommendation, ModelSize 노출
 * - TEST_B: 현재 브랜치 (신규) - 사이즈 탭에 SizeRecommendation, ModelSize 노출
 */
export function useSizeTabABT() {
  const { feature_list, isLoading } = useDisplayABT({
    keys: [`${BASE_KEY}_CTRL_A`],
  });

  const isTestGroup = feature_list.includes(`${BASE_KEY}_TEST_B`);
  const isControlGroup = !isTestGroup;

  return { isTestGroup, isControlGroup, isLoading };
}
